import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseFormListComponent } from 'src/app/shared/components/base-form/base-form-list.component';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Misc } from '../util/misc';
import { EstimativaDuplicarComponent } from '../estimativa/estimativa-duplicar.component';
import { Estimativa } from 'src/app/models/estimativa.model';
import { Status } from 'src/app/models/status.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { ProjetoService } from 'src/app/services/projeto.service';
import { StatusService } from 'src/app/services/status.service';
import { UtilService } from 'src/app/services/util.service';
import { Cliente } from 'src/app/models/cliente.model';
import { Observable, forkJoin } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FilterEstimativa } from 'src/app/models/filter/filter-estimativa';
import { EstimativaNovaComponent } from '../estimativa/estimativa-nova.component';
import { ClienteService } from 'src/app/services/cliente.service';
import { EstimativaTipoService } from 'src/app/services/estimativa-tipo.service';
import {
  EstimativaStatusConstants,
  PerfilConstants,
  TipoEstimativaConstants,
} from 'src/app/models/constants/constants';
import { PriceEstimativaExcluirDialogComponent } from './price-estimativa-excluir-dialog/price-estimativa-excluir-dialog.component';
import { TipoProjetoService } from 'src/app/services/tipoProjeto.service';
import { Overlay } from '@angular/cdk/overlay';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-price-estimativa-list',
  templateUrl: './price-estimativa-list.component.html',
  styleUrls: ['./price-estimativa-list.component.scss'],
})
export class PriceEstimativaListComponent extends BaseFormListComponent<Estimativa> implements OnInit {
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  estimativas: Estimativa[] = [];
  displayedColumns: string[] = ['deletar', 'cliente', 'crm', 'projeto', 'nome', 'tipo', 'data', 'status', 'acao'];
  dataSource = new MatTableDataSource<Estimativa>();

  projetoId = 0;
  clienteId: number;

  formPesquisa: UntypedFormGroup;
  status: Status[] = [];
  loading = true;

  titulo = '';
  crm: string;
  tipo: string;

  mostrarBotoes = true;
  statusId = Array<number>(0);

  clientes: Array<Cliente> = [];
  clientesFiltrada: Observable<Array<Cliente>> = null;

  delivery: boolean;
  userId: number;

  filtroCliente: UntypedFormControl = new UntypedFormControl();

  isAdmin = false;
  isSolution = false;
  isDelivery = false;
  isAdministrador = false;

  clientePesquisado: any;
  projetoPesquisado: any;

  constructor(
    private estimativaTipoService: EstimativaTipoService,
    private clienteService: ClienteService,
    private estimativaService: EstimativaService,
    private projetoService: ProjetoService,
    private statusService: StatusService,
    private tipoProjetoService: TipoProjetoService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    public utilService: UtilService,
    private toastr: ToastrComponent,
    private dialog: MatDialog,
    public misc: Misc,
    private overlay: Overlay,
    public activatedRoute: ActivatedRoute,
  ) {
    super(estimativaService);
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ngOnInit() {
    const subscriptions: any = {};

    const type = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
    this.userId = type.id;

    this.delivery = type.perfil.some((p) => p.id === PerfilConstants.ID_PERFIL_DELIVERY);
    this.isAdmin = type.perfil.some((p) => p.id === PerfilConstants.ID_PERFIL_ADMINISTRADOR);

    // setar antes de decidir endpoint de clientes
    this.isSolution = this.utilService.isSolution();
    this.isDelivery = this.utilService.isDelivery();
    this.isAdministrador = this.utilService.isAdmin();

    // Solution carrega clientes como Admin (evita lista vazia por unidade/permissão)
    if (this.isAdmin || this.isSolution) {
      subscriptions.clientes = this.clienteService.GetAllIncludeNotActive();
    } else {
      const unidadeId = this.utilService.getUnidadeId();
      subscriptions.clientes = this.clienteService.getAllByUnidade(unidadeId);
    }

    forkJoin(subscriptions)
      .subscribe({
        next: (result: any) => {
          const raw = result?.clientes;

          const items: Cliente[] = Array.isArray(raw) ? raw : (raw?.items ?? []);

          this.clientes = items;

          this.clientesFiltrada = this.filtroCliente.valueChanges.pipe(
            startWith(''),
            map((value) => this._filter(value)),
          );

          // opcional: dispara para já ter stream com todos
          this.filtroCliente.setValue(this.filtroCliente.value ?? '', { emitEvent: true });
        },

        error: (error) => {
          this.misc.processError(error, 'Não foi possível carregar os dados da tela.');
        },
      })
      .add(() => {
        this.loading = false;
      });

    this.projetoId = this.activatedRouter.snapshot.params.projetoId || 0;
    if (this.activatedRouter.snapshot.params.statusId && this.activatedRouter.snapshot.params.statusId !== '0') {
      this.statusId = this.activatedRouter.snapshot.params.statusId.split(',').map(Number);
    }

    this.createForm();

    this.statusService.getAll().subscribe((status) => {
      this.status = status.items;
    });

    if (this.projetoId > 0) {
      this.projetoService.getById(this.projetoId).subscribe((result) => {
        if (result.usuarioId !== this.utilService.getUserId()) {
          this.router.navigate(['/access-denied']);
          return;
        }

        this.titulo = result.nome;
        this.clienteId = result.clienteId;
        this.crm = result.crmId;
      });

      this.displayedColumns.shift();
    } else {
      this.titulo = 'Consulta Estimativas';
      this.utilService.setMessage('');
      this.mostrarBotoes = false;
    }

    this.verificaFiltro();
  }

  verificaFiltro() {
    this.activatedRoute.queryParams.subscribe((result) => {
      this.projetoPesquisado = result.proposta;
    });

    if (this.projetoPesquisado == undefined) {
      this.pesquisar(true);
    }

    if (this.projetoPesquisado != undefined) {
      this.pegarDadosPainelGeral();
    }
  }

  pegarDadosPainelGeral() {
    this.formPesquisa.controls['projeto'].setValue(this.projetoPesquisado);
    this.formPesquisa.controls['statusId'].setValue([
      EstimativaStatusConstants.ID_ESTIMATIVA_ELABORACAO,
      EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA,
    ]);

    this.loading = true;

    const estimativa = {
      projetoId: this.projetoId,
      projeto: this.projetoPesquisado,
      nome: this.formPesquisa.value.estimativa,
      tipo: this.formPesquisa.value.tipo,
      statusId: this.formPesquisa.value.statusId,
      usuarioId: this.utilService.getUserId(),
      clienteId: this.formPesquisa.value.cliente ? this.formPesquisa.value.cliente.id : 0,
      crmId: this.formPesquisa.value.projeto,
    } as FilterEstimativa;

    this.estimativaService.pesquisar(estimativa).subscribe((estimativas) => {
      this.loading = false;

      // mantém a regra antiga: admin não vê delivery
      this.estimativas = this.isAdmin
        ? estimativas.items.filter((e) => e.estimativaTipoId !== TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY)
        : estimativas.items;

      this.dataSource = new MatTableDataSource<Estimativa>(this.estimativas);
      this.dataSource.paginator = this.paginator;
    });
  }

  mostrarMinhasEstimativas(value: any) {
    const minhasEstimativasIsChecked = value.checked == true;
    this.pesquisar(true, minhasEstimativasIsChecked);
  }

  createForm() {
    this.formPesquisa = this.fb.group({
      projeto: [null],
      estimativa: [null],
      cliente: [null],
      statusId: [this.statusId],
      tipo: [this.tipo],
      minhasEstimativas: [null],
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(EstimativaNovaComponent, {
      width: '600px',
      minWidth: '500px',
      panelClass: 'default-dialog-container',
      hasBackdrop: true,
      disableClose: true,
      autoFocus: true,
      restoreFocus: false,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      closeOnNavigation: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.router.navigate(['price/projeto/estimativa-edit/' + result]);
    });
  }

  openDialogExcluir(element: any): void {
    const dialogRef = this.dialog.open(PriceEstimativaExcluirDialogComponent, {
      width: '500px',
      panelClass: 'default-dialog-container',
      data: element,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.pesquisar(false);
      }
    });
  }

  recuperaNomeStatus() {
    let nomeStatus = '';

    if (this.status.length > 0 && this.formPesquisa.value.statusId.length > 0) {
      nomeStatus = this.status[this.status.findIndex((s) => s.id === this.formPesquisa.value.statusId[0])].nome;
    }

    return nomeStatus;
  }

  voltar() {
    if (this.projetoId > 0) {
      this.router.navigate(['price/projeto/' + this.clienteId]);
    } else {
      this.router.navigate(['painel-geral']);
    }
  }

  pesquisar(carregarClientes: boolean, minhasEstimativasIsChecked?: boolean) {
    this.formPesquisa.controls['minhasEstimativas'].setValue(minhasEstimativasIsChecked);
    this.loading = true;

    const estimativa = {
      projetoId: this.projetoId,
      projeto: this.formPesquisa.value.projeto,
      nome: this.formPesquisa.value.estimativa,
      tipo: this.formPesquisa.value.tipo,
      statusId: this.formPesquisa.value.statusId,
      usuarioId: this.utilService.getUserId(),
      clienteId: this.formPesquisa.value.cliente ? this.formPesquisa.value.cliente.id : 0,
      crmId: this.formPesquisa.value.projeto,
    } as FilterEstimativa;

    this.estimativaService.pesquisar(estimativa, minhasEstimativasIsChecked).subscribe((estimativas) => {
      const resultado = estimativas.items;

      if (this.delivery) {
        this.estimativas = resultado.filter(
          (e) =>
            (e.estimativaTipoId === TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_PROJETO &&
              e.estimativaStatusId === EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) ||
            e.estimativaTipoId === TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_BODYSHOP,
        );
      } else if (this.isAdmin || this.isSolution) {
        this.estimativas = resultado.filter(
          (e) => e.estimativaTipoId !== TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_DELIVERY,
        );

        if (minhasEstimativasIsChecked) {
          this.estimativas = this.estimativas.filter((e) => e.usuarioId === this.userId);
        }
      } else {
        this.estimativas = resultado;
      }

      this.dataSource = new MatTableDataSource<Estimativa>(this.estimativas);

      if (this.dataSource.filteredData.length === 0) {
        this.toastr.mostrarMensagem('aviso', 'Aviso', 'Nenhuma estimativa encontrada.');
      }

      this.dataSource.paginator = this.paginator;
      this.loading = false;
    });
  }

  carregaCliente(cliente: Cliente) {
    this.formPesquisa.controls['minhasEstimativas'].setValue(false);

    this.formPesquisa.patchValue({ cliente });

    // mantém o autocomplete consistente
    this.filtroCliente.setValue(cliente, { emitEvent: false });

    this.pesquisar(false);
  }

  displayFn(cliente: Cliente): string {
    return cliente && cliente.nome ? cliente.nome : '';
  }

  private _filter(value: any): Cliente[] {
    // value pode ser: string (digitando), Cliente (selecionado) ou null
    const nome = typeof value === 'string' ? value : (value?.nome ?? '');
    const filterValue = (nome || '').toLowerCase();

    // se vazio, retorna todos
    if (!filterValue) return this.clientes;

    return this.clientes.filter((c) => (c.nome || '').toLowerCase().includes(filterValue));
  }

  verificaCliente(valor: any) {
    setTimeout(() => {
      if (!this.filtroCliente.value || !this.filtroCliente.value?.id) {
        this.filtroCliente.reset();
        this.formPesquisa.patchValue({ cliente: null });
        this.pesquisar(false);
      }
      {
        valor = null;
        this.filtroCliente.reset();
        this.pesquisar(false);
      }
    }, 500);
  }

  openDuplicar(estimativa: any): void {
    const estimtvId = Number(estimativa.id);
    this.dialog
      .open(EstimativaDuplicarComponent, {
        width: '600px',
        panelClass: 'default-dialog-container',
        data: { usuarioId: this.userId, estimtvId, element: estimativa, edit: true },
        hasBackdrop: true,
        disableClose: true,
        autoFocus: true,
        restoreFocus: false,
        scrollStrategy: this.overlay.scrollStrategies.block(),
        closeOnNavigation: false,
      })
      .afterClosed()
      .subscribe();
  }

  disableDuplicationForDeliveryProfile(estimativa: Estimativa): boolean {
    if (this.delivery == true && estimativa.estimativaTipoId == TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_BODYSHOP) {
      return false;
    }

    if (
      this.delivery == true &&
      estimativa.estimativaTipoId === TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_PROJETO &&
      estimativa.estimativaStatusId === EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA
    ) {
      return false;
    }

    if (this.isAdmin == true) {
      return false;
    }

    return true;
  }

  onSubmit(evt: Event) {
    evt.preventDefault();
  }

  onFocusCliente() {
    this.filtroCliente.setValue(this.filtroCliente.value ?? '', { emitEvent: true });
    if (this.clientes?.length) this.autocompleteTrigger.openPanel();
  }
}
